import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { YPageShell, YPageShellBody } from '../../ui/shell';
import { ToolkitShellTabs } from '../toolkit/components/ToolkitShellTabs';
import { hasEntitlement, parseEntitlements } from './entitlements';
import { fetchProfile, getCachedProfile } from './profileCache';
import { ProPanel } from './ProPanel';

const FREE = {
  plan: 'free',
  entitlements: { clubs: false, toolkit: false, parcels: false },
};

export async function fetchEntitlementsFromProfile() {
  const res = await fetchProfile(api);
  return parseEntitlements(res?.data);
}

function entitlementsFromSharedCache() {
  const cached = getCachedProfile({ allowStale: true });
  return cached ? parseEntitlements(cached) : null;
}

function GateShell({ testId, shell, children }) {
  if (shell === 'toolkit') {
    return (
      <YPageShell testId={testId} className="feed-mgmt-shell">
        <ToolkitShellTabs />
        <YPageShellBody>{children}</YPageShellBody>
      </YPageShell>
    );
  }
  return (
    <YPageShell testId={testId}>
      <YPageShellBody>{children}</YPageShellBody>
    </YPageShell>
  );
}

export function ProGate({
  children,
  entitlement,
  fetchEntitlements = fetchEntitlementsFromProfile,
  shell = null,
}) {
  const usesSharedProfile = fetchEntitlements === fetchEntitlementsFromProfile;
  const cachedParsed = usesSharedProfile ? entitlementsFromSharedCache() : null;
  const [status, setStatus] = useState(cachedParsed ? 'ready' : 'loading');
  const [parsed, setParsed] = useState(cachedParsed || FREE);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const next = await fetchEntitlements();
        if (cancelled) return;
        setParsed(next);
      } catch {
        if (cancelled) return;
        if (!getCachedProfile({ allowStale: true })) setParsed(FREE);
      } finally {
        if (!cancelled) setStatus('ready');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchEntitlements]);

  if (status === 'ready' && hasEntitlement(parsed, entitlement)) {
    return children;
  }

  const loading = status === 'loading';
  return (
    <GateShell testId={`${entitlement}-pro-gate`} shell={shell}>
      {loading ? (
        <p data-testid={`${entitlement}-pro-gate-loading`}>Loading…</p>
      ) : (
        <ProPanel />
      )}
    </GateShell>
  );
}

export function ToolkitProGate({ children, fetchEntitlements }) {
  return (
    <ProGate entitlement="toolkit" shell="toolkit" fetchEntitlements={fetchEntitlements}>
      {children}
    </ProGate>
  );
}

export function ClubsProGate({ children, fetchEntitlements }) {
  return (
    <ProGate entitlement="clubs" fetchEntitlements={fetchEntitlements}>
      {children}
    </ProGate>
  );
}
